/**
 *
 * @param url for example "http://username:password@localhost:257/deploy/?asd=asd#asd"
 *
```javascript
{
    "hash": "#asd",
    "host": "username:password@localhost:257",
    "hostname": "localhost",
    "href": "http://username:password@localhost:257/deploy/?asd=asd#asd",
    "origin": "http://username:password@localhost:257",
    "password": "password",
    "pathname": "/deploy/",
    "port": "257",
    "protocol": "http:",
    "search": "?asd=asd",
    "username": "username"
}
```
 */
export function parseUrl(url) {
    const m = url.match(/^(([^:\/?#]+:)?(?:\/\/((?:([^\/?#:]*):([^\/?#:]*)@)?([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/);
    if (!m) {
        throw new Error(`Invalid url: ${url}`);
    }
    const r = {
        hash: m[10] || '', // #asd
        host: m[3] || '', // localhost:257
        hostname: m[6] || '', // localhost
        href: m[0] || '', // http://username:password@localhost:257/deploy/?asd=asd#asd
        origin: m[1] || '', // http://username:password@localhost:257
        pathname: m[8] || (m[1] ? '/' : ''), // /deploy/
        port: m[7] || '', // 257
        protocol: m[2] || '', // http:
        search: m[9] || '', // ?asd=asd
        username: m[4] || '', // username
        password: m[5] || '', // password
    };
    if (r.protocol.length === 2) {
        r.protocol = 'file:///' + r.protocol.toUpperCase();
        r.origin = r.protocol + '//' + r.host;
    }
    r.href = r.origin + r.pathname + r.search + r.hash;
    return m && r;
}
